import { AxiosResponse } from 'axios';

import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const handleFetchErrorsSwal = async (response: Response) => {
    if (!response.ok) {
        const error = await response.json();
        // @ts-ignore
        swal({
            text: error.message,
            cancel: false,
            confirm: true,
            button: {
                text: i18next.t('swal.button.text.ok'),
                value: true,
                visible: true,
                className: 'btn btn-secondary',
            },
        });
        throw new Error(error.message);
    }
    return response;
};
export const handleAxiosFetchErrorsSwal = (error: IDataResponse<null>) => {
    // @ts-ignore
    swal({
        text: error.message,
        cancel: false,
        confirm: true,
        button: {
            text: i18next.t('swal.button.text.ok'),
            value: true,
            visible: true,
            className: 'btn btn-secondary',
        },
    });
};
